import { ComponentProps, ReactElement } from "react";
import Select, { SelectOption } from "./Select.component";
import styles from "./StandardSelect.module.css";
import cx from "classnames";
import Text from "../Text/Text.component";
import { ReactComponent as DownIcon } from "@jnctn/icons/down.svg";

export function StandardSelectOption({
  value,
  children,
}: ComponentProps<typeof SelectOption>) {
  return <SelectOption value={value}>{children}</SelectOption>;
}

export default function StandardSelect({
  children,
  onChange,
  value,
  icon,
  className,
  label,
}: ComponentProps<typeof Select> & { icon?: ReactElement }) {
  const selectedValue = (Array.isArray(children) ? children : [children]).find(
    (child) => child.props.value === value
  )?.props.children;
  return (
    <div className={cx(styles.root, className)}>
      {icon !== undefined ? icon : null}
      <Text size="body1" color="primary" weight="semibold" textAlign="center">
        {selectedValue || value}
      </Text>
      <Select onChange={onChange} value={value} label={label}>
        {children}
      </Select>
      <Text size="body1" color="primary">
        <DownIcon className="w-8 h-8" />
      </Text>
    </div>
  );
}
